export default {"src":"/_next/static/media/pair-3.f7377a39.svg","height":449,"width":456,"blurWidth":0,"blurHeight":0};